import React from 'react';
import ReactDOM from 'react-dom';
import { Amplify } from 'aws-amplify';
import config from './config';
import App from './App';
import './index.css';

Amplify.configure({
  Auth: {
    region: config.cognito.region,
    userPoolId: config.cognito.userPoolId,
    userPoolWebClientId: config.cognito.userPoolWebClientId
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
